import React from 'react'

import $ from 'jquery'
import moment from 'moment'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import BottomButton from 'app/bond_cover/renters/sharedComponent/bottom_buttons_connection'
import {
  Alert,
  Box,
  Modal,
  TextSpan,
} from 'app/components/design-system-components'
import { AlertInfo } from 'app/components/design-system-components/AlertInfo'
import Flex from 'app/components/design-system-components/Flex'
import DoneRounded from 'app/components/design-system-components/icons/actions/DoneRounded'
import * as Display from 'app/components/display/display'
import * as Headers from 'app/components/display/text/standard_text/standard-headings/component'
import * as Text from 'app/components/display/text/text_component'
import ProgressBarComponent from 'app/components/progress_bar/connection'
import { pmsBrands, sendApplicantPMSSetting } from 'app/constants/pms.constants'
import { ledgerAttachmentsCmpDomId } from 'app/constants/rental-history.constants'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import {
  DIRECT_CONNECT_PROVIDER_NAME,
  UTILITY_CONNECTION_MODAL_QUERY_KEY,
} from 'app/match/apply/application_summary_before_submit/application_summary_before_submit.constants'
import AddressHistoryComponent from 'app/match/apply/application_summary_before_submit/components/address_history_container/component'
import ApplicationClosedModal from 'app/match/apply/application_summary_before_submit/components/application_closed_modal/ApplicationClosedModal'
import BackgroundCheckContainer from 'app/match/apply/application_summary_before_submit/components/background_check_container/component'
import DisclosureConsentContainer, {
  InspectionTypeNotSet,
  InspectionTypePhysical,
  InspectionTypeRemote,
  PhysicalAndRemoteAcceptanceType,
} from 'app/match/apply/application_summary_before_submit/components/disclosure_consent_container/component'
import {
  ABORIGINAL_OR_TORRES_STRAIGHT_ISLANDER,
  ANOTHER_LESSOR_OR_AGENT_DEBT,
  ANOTHER_LESSOR_OR_AGENT_DEBT_DETAILS,
  OWN_PROPERTIES_OR_LAND,
  OWN_PROPERTIES_OR_LAND_DETAILS,
  PREVIOUS_TENANCIES_TERMINATION,
  PREVIOUS_TENANCIES_TERMINATION_DETAILS,
  REASON_AFFECT_RENT_PAYMENT,
  REASON_AFFECT_RENT_PAYMENT_DETAILS,
  STATE_OPTED_IN_UTILITY_CONNECTION,
  TEAM_MEMBER_ASSOCIATION,
  Yes,
  yesOrNoDisclosureQuestions,
} from 'app/match/apply/application_summary_before_submit/components/disclosure_consent_container/disclosure_questions.constants'
import EmergencyContactContainer from 'app/match/apply/application_summary_before_submit/components/emergency_container/component'
import EmploymentContainer from 'app/match/apply/application_summary_before_submit/components/employment_container/component'
import { HouseholdContainer } from 'app/match/apply/application_summary_before_submit/components/household_container/component'
import IdentityDocumentsContainer from 'app/match/apply/application_summary_before_submit/components/identity_container/component'
import IncomeContainer from 'app/match/apply/application_summary_before_submit/components/income_container/component'
import OtherDocumentContainer from 'app/match/apply/application_summary_before_submit/components/other_documents_container/component'
import PetsContainer from 'app/match/apply/application_summary_before_submit/components/pet_container/component'
import PreferenceComponent from 'app/match/apply/application_summary_before_submit/components/preference_container/component'
import PersonalReferenceContainer from 'app/match/apply/application_summary_before_submit/components/reference_container/component'
import RenterVerifiedFinancialsContainer from 'app/match/apply/application_summary_before_submit/components/renter_verified_financials_container/component'
import StudentContainer from 'app/match/apply/application_summary_before_submit/components/student_container/component'
import TenancyDatabases from 'app/match/apply/application_summary_before_submit/components/tenancy_databases'
import * as SummaryHeaders from 'app/match/apply/application_summary_before_submit/shared_components/headers/component'
import BasicModal from 'app/modals/basic_modal'
import { getRenterProfile } from 'app/services/http/users'
import * as snugLogger from 'app/services/snugLogger'
import * as snugNotifier from 'app/services/snugNotifier'
import DisclosureQuestionsDisplay from 'app/shared_components/DisclosureQuestionsDisplay'
import { history } from 'app/shared_components/router'
import { LinkStyleText } from 'app/shared_components/shared_styled_component'
import * as validations from 'app/shared_components/validations'
import { AgencyApplicationsLimitAlert } from 'app/sm/apply/components/AgencyApplicationsLimitAlert'
import { isRentalLedgerRequiredByAgencyPolicy } from 'app/sm/apply/rental-ledger-required-policy.helpers'
import {
  getMissingRequiredRentalLedgerHistoryGUIDs,
  getSubmitFinalApplicationErrorMessage,
  isMissingRequiredRentalLedgerSubmitError,
} from 'app/sm/apply/submit-error.helpers'
import Spinner from 'app/sm/common/spinner'
import { isDocAutoDeleted } from 'app/sm/docs_helpers'
import {
  isApplicationAccepted,
  isApplicationApplyAnywhere,
  isPropertyLeased,
  parseDataUtil,
  smokingType,
  standardUTCFormat,
  urlTo,
} from 'app/sm/helpers'
import {
  IDENTITY_POINT_THRESHOLD_VALUE,
  IDENTITY_POINT_TOAST_ERROR,
} from 'app/sm/team_viewing_preference/team_viewing_preference_const'
import {
  checkIfBGCheckNotSupportedInState,
  getStateDemonym,
} from 'app/utils/address/helpers'
import * as applicationHelpers from 'app/utils/applications/helpers'
import { APPLY_ANYWHERE_APPLICATION } from 'app/utils/applications/helpers'
import * as dateTimeHelpers from 'app/utils/datetime/helpers'
import { isEmpty } from 'app/utils/objects/helpers'
import * as stringHelpers from 'app/utils/strings/helpers'
import { isFinancialInsightsSettingEnabled } from 'config/features'

import 'app/match/apply/application_summary_before_submit/styles/application_summary_before_submit_container/style.scss'

const StyledDoneIconContainer = styled(Flex)`
  background-color: ${theme.colors.success200};
  border-radius: 100%;
`

export class ApplicationSummaryContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitBtnClicked: false,
      loadingError: '',
      actionError: false,
      smokingInfo: smokingType.NonSmoker,
      optedInAsSmoker: false,
      optedToAcceptCondition: false,
      optedToAcceptDisclosureConsent: true,
      optedToReceiveUtilityConnection: true,
      directConnectTermsViewed: false,
      optedToReceiveRayWhiteConciergeService: false,
      optedToRequirePostingClause: false,
      optedToReceiveBondLoanInformation: false,
      optedInToPetConsent: false,
      optedToReceiveEasyBondpay: false,
      teamSettingInfo: {},
      isKolmeoActive: false,
      showingToast: false,
      conditionAcceptanceType: PhysicalAndRemoteAcceptanceType, // default
      propertyInspectionType: InspectionTypeNotSet,
      propertyInspectedDate: null,
      renterHasJointApplication: false,
      showViewingCheckinModal: false,
      openAAModal: false,
      inspectedDateError: '',
      optedToSkipViewingDisclosures: false,
      disclosureYesOrNoAnswers: {
        [PREVIOUS_TENANCIES_TERMINATION]: null,
        [PREVIOUS_TENANCIES_TERMINATION_DETAILS]: null,
        [ANOTHER_LESSOR_OR_AGENT_DEBT]: null,
        [ANOTHER_LESSOR_OR_AGENT_DEBT_DETAILS]: null,
        [REASON_AFFECT_RENT_PAYMENT]: null,
        [REASON_AFFECT_RENT_PAYMENT_DETAILS]: null,
        [OWN_PROPERTIES_OR_LAND]: null,
        [OWN_PROPERTIES_OR_LAND_DETAILS]: null,
        [TEAM_MEMBER_ASSOCIATION]: null,
        [ABORIGINAL_OR_TORRES_STRAIGHT_ISLANDER]: null,
      },
      propertyStatus: 0,
      propertyArchived: false,
      applicationsCloseModalOpen: false,
      optedToAcceptRetainRentalProfile: false,
      renterProfileGUID: '',
      renterSummary: {},
      autoDeletedDocumentsModalOpen: false,
      submitLedgerRecoveryError: null,
      financialInsightsReport: null,
    }
    this.addressHistorySectionRef = React.createRef()
    this.toggleDisclosureOptions = this.toggleDisclosureOptions.bind(this)
  }

  componentDidMount() {
    const {
      match: {
        params: { applicationId },
      },
      fetchRenterSummary,
      retrieveReputationPreference,
      setBackUrl,
      fetchCompleteness,
      fetchTeamSettingInformation,
      applicant,
      loading = {},
    } = this.props

    const backUrl = window.location.pathname
    $('#index').addClass('no-navbar-menu')
    setBackUrl(backUrl)
    this.setState({ spinner: true })

    // Check if applicant is loading or null and show appropriate loading state
    if (
      loading.applicationSummary ||
      loading.propertySummary ||
      isEmpty(applicant)
    ) {
      this.setState({
        spinner: true,
        applicantLoading: true,
      })
    }

    fetchRenterSummary(applicationId)
      .then(({ renterSummary }) => {
        const {
          property = {},
          displayProfileRetentionExtendedPeriod,
          displayProfileRetentionPeriod,
          displaySuccessfulApplicantRetentionPeriod,
        } = renterSummary

        const { archived = false, status = '' } = property || {}
        const { address = {} } = property || {}
        const { state = '' } = address || {}
        const showOptionToRetainRentalProfile = Boolean(
          displayProfileRetentionExtendedPeriod,
        )

        this.setState(
          {
            renterSummary,
            propertyStatus: status,
            propertyArchived: archived,
            spinner: false,
            showOptionToRetainRentalProfile,
            displayProfileRetentionPeriod,
            displayProfileRetentionExtendedPeriod,
            displaySuccessfulApplicantRetentionPeriod,
          },
          () => {
            const { agencyID = '' } = renterSummary.property || {}
            if (agencyID) {
              fetchTeamSettingInformation(
                agencyID,
                'application,integrations,notifications',
              )
                .then((teamSettingInfo) => {
                  const { integrations } = teamSettingInfo
                  const parsedIntegrations =
                    parseDataUtil.convertObjValueFromStringToBoolean(
                      integrations,
                    )
                  const isKolmeoActive =
                    parsedIntegrations[
                      `${sendApplicantPMSSetting}.${pmsBrands.kolmeo.id}`
                    ]
                  this.setState({ teamSettingInfo, isKolmeoActive })
                })
                .catch((error) => {
                  this.setState({ error })
                })

              if (isFinancialInsightsSettingEnabled()) {
                // Gate on per-agency financial_insights_enabled to match
                // proof_of_income_container.jsx behaviour.
                fetchTeamSettingInformation(agencyID, 'ai')
                  .then((aiSettings) => {
                    if (aiSettings?.ai?.financial_insights_enabled !== 'true') {
                      return
                    }
                    this._fiAbortController = new AbortController()
                    const statusUrl = `${window.location.origin}/v2/financial-insights/status`
                    fetch(statusUrl, {
                      credentials: 'include',
                      headers: { Accept: 'application/json' },
                      signal: this._fiAbortController.signal,
                    })
                      .then((r) => {
                        // 204 No Content is a valid empty-state; r.json() would throw.
                        if (!r.ok || r.status === 204) return null
                        return r.json()
                      })
                      .then((result) => {
                        const data = result?.data ?? result
                        if (
                          data?.session?.status === 'completed' &&
                          data?.report
                        ) {
                          this.setState({
                            financialInsightsReport: data.report,
                          })
                        }
                      })
                      .catch((err) => {
                        // Best-effort — non-ok HTTP responses are silently
                        // ignored above; this .catch fires on network errors.
                        snugLogger.warn(
                          '[FinancialInsights] status fetch failed',
                          { error: err },
                        )
                      })
                  })
                  .catch(() => {
                    // AI settings unavailable — skip FI fetch silently.
                  })
              }
            }
            const { utilityProvider = {} } = renterSummary
            const { name = '' } = utilityProvider
            if (
              state === STATE_OPTED_IN_UTILITY_CONNECTION &&
              name === DIRECT_CONNECT_PROVIDER_NAME
            ) {
              this.setState({
                optedToReceiveUtilityConnection: false,
              })
            }
          },
        )

        if (showOptionToRetainRentalProfile) {
          getRenterProfile().then(({ autoRemovalExtended, guidID }) => {
            this.setState({
              optedToAcceptRetainRentalProfile: Boolean(autoRemovalExtended),
              renterProfileGUID: guidID,
            })
          })
        }
      })
      .catch((error) => {
        this.setState({ loadingError: error }, this.reactToastify)
      })
    retrieveReputationPreference()
      .then(({ preference }) => {
        this.setState({ preference })
      })
      .catch((error) => {
        this.setState({ loadingError: error }, this.reactToastify)
      })
    fetchCompleteness()

    // Only proceed with applicant operations if applicant exists
    if (!isEmpty(applicant)) {
      this.mapYesOrNoDisclosureAnswers(applicant)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: { applicationId },
      },
      applicant,
      loading = {},
    } = this.props

    // Update loading state when applicant data arrives
    if (prevProps.loading !== loading) {
      const isLoading = loading.applicationSummary || loading.propertySummary
      if (this.state.applicantLoading && !isLoading) {
        this.setState({ applicantLoading: false })

        if (isEmpty(applicant)) {
          // Log warning for debugging
          snugLogger.warn(
            'Error Investigation: Suspicious applicant on mount',
            {
              tags: {
                applicationID: applicationId,
                url: window.location.href,
                referrer: document.referrer,
                searchParams: window.location.search,
                applicantType: typeof applicant,
                applicantGuidID: applicant?.guidID || 'null',
                hasApplicant: !!applicant,
                isApplicantEmpty: isEmpty(applicant),
                loadingApplicationSummary: loading?.applicationSummary || false,
                loadingPropertySummary: loading?.propertySummary || false,
                timestamp: Date.now(),
              },
            },
          )
          return
        }
      }
    }

    if (
      prevProps.applicant &&
      applicant &&
      (prevProps.applicant || {}).guidID !== (applicant || {}).guidID &&
      applicant?.applied
    ) {
      if (applicant && applicant.isPrimary) {
        this.setState({
          optedToReceiveUtilityConnection:
            applicant.optedToReceiveUtilityConnection,
          directConnectTermsViewed: applicant.directConnectTermsViewed,
          optedToReceiveRayWhiteConciergeService:
            applicant.optedToReceiveRayWhiteConciergeService,
          optedToReceiveBondLoanInformation:
            applicant.optedToReceiveBondLoanInformation,
          optedToRequirePostingClause: applicant.optedToRequirePostingClause,
        })
      }
      this.setState({
        optedToAcceptCondition: applicant?.optedToAcceptCondition,
        optedToAcceptDisclosureConsent:
          applicant?.optedToAcceptDisclosureConsent,
        smokingInfo: applicant?.smokingInfo,
        optedInAsSmoker: applicant?.smokingInfo === smokingType.Smoker,
        optedInToPetConsent: applicant?.optedInToPetConsent,
        conditionAcceptanceType: applicant?.conditionAcceptanceType,
        propertyInspectionType: applicant?.propertyInspectionType,
        propertyInspectedDate: applicant?.propertyInspectedDate,
        optedToReceiveEasyBondpay: applicant?.optedToReceiveEasyBondpay,
        optedToSkipViewingDisclosures: applicant?.optedToSkipViewingDisclosures,
      })
      this.mapYesOrNoDisclosureAnswers(applicant)
    }
  }

  componentWillUnmount() {
    $('#index').removeClass('no-navbar-menu')
    this._fiAbortController?.abort()
  }

  mapYesOrNoDisclosureAnswers(applicant) {
    if (
      !applicant ||
      !applicant.disclosures ||
      typeof applicant.disclosures !== 'object'
    )
      return

    this.setState({
      disclosureYesOrNoAnswers: {
        [PREVIOUS_TENANCIES_TERMINATION]:
          applicant.disclosures[PREVIOUS_TENANCIES_TERMINATION],
        [PREVIOUS_TENANCIES_TERMINATION_DETAILS]:
          applicant.disclosures[PREVIOUS_TENANCIES_TERMINATION_DETAILS],
        [ANOTHER_LESSOR_OR_AGENT_DEBT]:
          applicant.disclosures[ANOTHER_LESSOR_OR_AGENT_DEBT],
        [ANOTHER_LESSOR_OR_AGENT_DEBT_DETAILS]:
          applicant.disclosures[ANOTHER_LESSOR_OR_AGENT_DEBT_DETAILS],
        [REASON_AFFECT_RENT_PAYMENT]:
          applicant.disclosures[REASON_AFFECT_RENT_PAYMENT],
        [REASON_AFFECT_RENT_PAYMENT_DETAILS]:
          applicant.disclosures[REASON_AFFECT_RENT_PAYMENT_DETAILS],
        [OWN_PROPERTIES_OR_LAND]: applicant.disclosures[OWN_PROPERTIES_OR_LAND],
        [OWN_PROPERTIES_OR_LAND_DETAILS]:
          applicant.disclosures[OWN_PROPERTIES_OR_LAND_DETAILS],
        [TEAM_MEMBER_ASSOCIATION]:
          applicant.disclosures[TEAM_MEMBER_ASSOCIATION],
        [ABORIGINAL_OR_TORRES_STRAIGHT_ISLANDER]:
          applicant.disclosures[ABORIGINAL_OR_TORRES_STRAIGHT_ISLANDER],
      },
    })
  }

  onApplyButtonClick = (
    applicant,
    applicationID,
    applicantSummary,
    providerName = '',
    greaterThanIDPointsThreshold = true,
  ) => {
    const { updateApplicantDisclosures } = this.props
    const {
      teamSettingInfo,
      renterSummary = {},
      propertyStatus,
      propertyArchived,
    } = this.state
    const { applicantHasViewingCheckin, isViewingCheckinEnabled } =
      renterSummary
    if (isEmpty(applicant)) {
      snugLogger.warn(
        'Error Investigation: Invalid applicant detected when submit application',
        {
          tags: {
            applicationID: applicationID,
            url: window.location.href,
            referrer: document.referrer,
            searchParams: window.location.search,
            applicantType: typeof applicant,
            applicantGuidID: applicant?.guidID || 'null',
            hasApplicant: !!applicant,
            isApplicantEmpty: isEmpty(applicant),
            applicationGuidID: renterSummary?.application?.guidID || 'null',
            applicantSummaryGuidID: applicantSummary?.guidID || 'null',
            timestamp: Date.now(),
          },
        },
      )
      this.toggleInvalidDataModal()
      this.setState({ submitBtnClicked: false })
      return
    }
    if (!applicantHasViewingCheckin && isViewingCheckinEnabled) {
      const renterHasJointApplication = this.state.renterHasJointApplication
      this.setState({
        showViewingCheckinModal: true,
        submitBtnClicked: false,
        renterHasJointApplication: applicant
          ? !applicant.isPrimary
          : false
          ? !renterHasJointApplication
          : renterHasJointApplication,
      })
      return false
    }
    const identityCapEnabled =
      teamSettingInfo &&
      teamSettingInfo.application &&
      teamSettingInfo.application.identity_cap_enabled &&
      teamSettingInfo.application.identity_cap_enabled === 'true'
    const disclosureRequest = this.getDisclosureRequest(
      applicant?.isPrimary || false,
    )
    const secondaryApplicantPayload = {
      applicantSummary,
      applicantDisclosure: disclosureRequest,
    }
    const { propertyOffer } = renterSummary
    const { ballotsEnabled = false } = propertyOffer || {}

    const offMarketProperty =
      isPropertyLeased(propertyStatus) || propertyArchived
    if (identityCapEnabled && !greaterThanIDPointsThreshold) {
      this.setState(
        {
          actionError: IDENTITY_POINT_TOAST_ERROR,
          submitBtnClicked: false,
        },
        this.reactToastify,
      )
      return false
    }

    if (this.hasAutoDeletedDocuments()) {
      this.setState({
        autoDeletedDocumentsModalOpen: true,
        submitBtnClicked: false,
      })
      return false
    }

    if (!this.validRequiredFields()) {
      this.setState({ submitBtnClicked: false })
      return null
    }
    // Validation passed – clear any stale actionError from previous attempt
    this.setState({ actionError: '' })

    if (this.state.submitLedgerRecoveryError) {
      this.setState({ submitLedgerRecoveryError: null })
    }

    if (ballotsEnabled) {
      if (applicant && applicant.isPrimary && !applicant.applied) {
        return this.submitApplicationAsPrimary(
          applicationID,
          disclosureRequest,
          providerName,
        )
      }
      if (applicant && !applicant.isPrimary && !applicant.applied) {
        return this.submitApplicationAsSecondary(
          applicationID,
          applicant.guidID,
          secondaryApplicantPayload,
          disclosureRequest,
          providerName,
        )
      }
      if (applicant?.applied) {
        updateApplicantDisclosures(applicant.guidID, disclosureRequest)
          .then(() => {
            history.push(
              urlTo('applyConfirmationSummaryBallot', {
                applicationId: applicationID,
              }),
            )
          })
          .catch((error) => {
            this.setState(
              {
                actionError: error,
                submitBtnClicked: false,
              },
              this.reactToastify,
            )
          })
      }
    } else {
      if (applicant?.applied) {
        updateApplicantDisclosures(applicant.guidID, disclosureRequest)
          .then(() => {
            history.push(
              urlTo('applyConfirmationSummary', {
                applicationId: applicationID,
              }),
            )
          })
          .catch((error) => {
            this.setState(
              {
                actionError: error,
                submitBtnClicked: false,
              },
              this.reactToastify,
            )
          })
      } else {
        if (offMarketProperty) {
          this.setState({
            applicationsCloseModalOpen: true,
            submitBtnClicked: false,
          })
        } else {
          if (applicant && applicant.isPrimary) {
            return this.submitApplicationAsPrimary(
              applicationID,
              disclosureRequest,
              providerName,
            )
          } else {
            return this.submitApplicationAsSecondary(
              applicationID,
              applicant?.guidID,
              secondaryApplicantPayload,
              disclosureRequest,
              providerName,
            )
          }
        }
      }
    }

    return null
  }

  onBookATimeButtonClicked = (property) => {
    if (property) {
      window.open(urlTo('applyRedirect', { slug: (property || {}).slug }))
    }
  }

  onChangeInspectionType = (propertyInspectionTypeID) => {
    const { actionError } = this.state
    return () => {
      this.setState(
        {
          optedToAcceptCondition: true,
          propertyInspectionType: propertyInspectionTypeID,
        },
        () => {
          if (
            this.state.conditionAcceptanceType ===
              PhysicalAndRemoteAcceptanceType &&
            (this.state.propertyInspectionType === InspectionTypeRemote ||
              this.state.propertyInspectionType === InspectionTypePhysical) &&
            actionError === stringHelpers.PROPERTY_CONDITION_ERROR_TEXT
          ) {
            this.setState({
              actionError: '',
            })
          }
        },
      )
    }
  }

  onEditClick = (queryString) => {
    return (forwardUrl) => {
      const { addRentalReputationBackUrl, setBackUrl } = this.props
      const backUrl = window.location.pathname + queryString
      addRentalReputationBackUrl(backUrl)
      setBackUrl(backUrl)
      history.push(forwardUrl + queryString)
    }
  }

  onPropertyInspectedDateUpdate = () => {
    return (data) => {
      let value = data.value
      if (data.error === '') {
        value =
          value !== ''
            ? moment(value).format(dateTimeHelpers.DATE_WITH_DASH)
            : ''
      }
      this.setState({
        propertyInspectedDate: value,
        inspectedDateError: data.error,
      })
    }
  }

  onSubmitClick = (
    applicant,
    applicationID,
    applicantSummary,
    providerName = '',
  ) => {
    const { renterSummary = {} } = this.state
    const { renterJointApplication = {} } = renterSummary
    if (renterJointApplication && renterJointApplication.applicant) {
      this.setState({
        renterHasJointApplication: true,
      })
      return
    }
    const { renterHasJointApplication } = this.state
    if (!renterHasJointApplication) {
      this.onApplyButtonClick(
        applicant,
        applicationID,
        applicantSummary,
        providerName,
      )
    }
  }

  onToggleModal = () => {
    const { applicant } = this.props
    const renterHasJointApplication = this.state.renterHasJointApplication
    this.setState({
      showViewingCheckinModal: !this.state.showViewingCheckinModal,
      submitBtnClicked: false,
      renterHasJointApplication:
        applicant && !applicant.isPrimary
          ? !renterHasJointApplication
          : renterHasJointApplication,
    })
  }

  onCloseModal = () => {
    this.setState({
      openAAModal: !this.state.openAAModal,
    })
  }

  toggleAutoDeletedDocumentsModal = () => {
    this.setState({
      autoDeletedDocumentsModalOpen: !this.state.autoDeletedDocumentsModalOpen,
    })
  }

  toggleApplicationsCloseModal = () => {
    this.setState({
      applicationsCloseModalOpen: !this.state.applicationsCloseModalOpen,
    })
  }

  toggleInvalidDataModal = () => {
    this.setState({
      showInvalidDataModal: !this.state.showInvalidDataModal,
    })
  }

  onClickOkButton = () => {
    this.setState({ submitBtnClicked: true, openAAModal: false })
    const { applicant, submittedApplication } = this.props
    const {
      match: {
        params: { applicationId },
      },
    } = this.props
    const { applicantSummary = {} } = submittedApplication
    const { renterSummary = {} } = this.state
    const { utilityProvider = {}, idDocumentsSummary = {} } = renterSummary
    const idPoint =
      idDocumentsSummary.identityCheckPoints >= IDENTITY_POINT_THRESHOLD_VALUE
    this.onSubmitClick(
      applicant,
      applicationId,
      applicantSummary,
      utilityProvider.name,
      idPoint,
    )
  }

  getDisclosureRequest(isApplicantPrimary) {
    const {
      optedToAcceptCondition,
      optedToAcceptDisclosureConsent,
      optedToReceiveUtilityConnection,
      directConnectTermsViewed,
      optedToReceiveRayWhiteConciergeService,
      optedToReceiveBondLoanInformation,
      optedToRequirePostingClause,
      smokingInfo,
      optedInToPetConsent,
      conditionAcceptanceType,
      propertyInspectionType,
      propertyInspectedDate,
      optedToReceiveEasyBondpay,
      disclosureYesOrNoAnswers,
      optedToSkipViewingDisclosures,
      optedToAcceptRetainRentalProfile,
      showOptionToRetainRentalProfile,
      renterProfileGUID,
    } = this.state

    const data = {
      isPrimary: isApplicantPrimary,
      optedToAcceptCondition,
      optedToAcceptDisclosureConsent,
      optedToReceiveUtilityConnection,
      directConnectTermsViewed,
      optedToReceiveRayWhiteConciergeService,
      optedToReceiveBondLoanInformation,
      optedToRequirePostingClause,
      smokingInfo,
      optedInToPetConsent,
      conditionAcceptanceType,
      propertyInspectionType,
      optedToReceiveEasyBondpay,
      optedToSkipViewingDisclosures,
      ...disclosureYesOrNoAnswers,
    }

    if (showOptionToRetainRentalProfile) {
      data.updateRenterProfileRequest = {
        guid: renterProfileGUID,
        autoRemovalExtended: optedToAcceptRetainRentalProfile,
      }
    }

    if (
      propertyInspectedDate !== null &&
      propertyInspectionType === InspectionTypePhysical
    ) {
      data.propertyInspectedDate = moment(propertyInspectedDate).format(
        standardUTCFormat,
      )
    }

    return data
  }

  btnTextChange = () => {
    const { applicant = {} } = this.props
    const { submitBtnClicked } = this.state
    const applyGTM = 'rental-application-submit-application'
    if (applicant && !applicant.applied) {
      return (
        <div
          className={`summary-submit-button ${applyGTM} ${
            submitBtnClicked && `button-spinning-spacing`
          }`}
        >
          Submit Application
          <i className={submitBtnClicked ? 'fa fa-spinner fa-pulse' : ''} />
        </div>
      )
    } else if (applicant && applicant.applied && applicant.isPrimary) {
      return (
        <div>
          Update
          <i className={submitBtnClicked ? 'fa fa-spinner fa-pulse' : ''} />
        </div>
      )
    }
    return ''
  }

  joinApplication = (applicant, application) => {
    const { slug, guidID } = application || {}
    const { submitJoinedApplication } = this.props
    const { optedToAcceptDisclosureConsent } = this.state

    if (!optedToAcceptDisclosureConsent) {
      this.setState(
        {
          actionError: stringHelpers.DISCLOSURE_CONSENT_ERROR_TEXT,
        },
        this.reactToastify,
      )
      return
    }
    const { renterSummary = {} } = this.state
    const { applicantHasViewingCheckin, isViewingCheckinEnabled } =
      renterSummary
    if (!applicantHasViewingCheckin && isViewingCheckinEnabled) {
      const renterHasJointApplication = this.state.renterHasJointApplication
      this.setState({
        showViewingCheckinModal: true,
        submitBtnClicked: false,
        renterHasJointApplication: applicant
          ? !applicant.isPrimary
          : false
          ? !renterHasJointApplication
          : renterHasJointApplication,
      })
      return false
    }
    const disclosureRequest = this.getDisclosureRequest(
      applicant?.isPrimary || false,
    )
    if (this.hasAutoDeletedDocuments()) {
      this.setState({
        autoDeletedDocumentsModalOpen: true,
        submitBtnClicked: false,
      })
      return false
    }
    if (slug) {
      submitJoinedApplication(slug, disclosureRequest)
        .then(() => {
          this.setState({
            renterHasJointApplication: false,
          })
          if (guidID) {
            const params = new URLSearchParams()
            params.set(UTILITY_CONNECTION_MODAL_QUERY_KEY, '1')
            history.push(
              `${urlTo('applyConfirmationSummary', {
                applicationId: guidID,
              })}?${params.toString()}`,
            )
          }
        })
        .catch((apiError) => {
          this.setState(
            {
              renterHasJointApplication: false,
              submitBtnClicked: false,
            },
            () => {
              snugNotifier.error(apiError)
            },
          )
        })
    }
  }

  showErrorToast = (errorMessage) => {
    if (!errorMessage) {
      return
    }
    if (this.state.showingToast === false) {
      snugNotifier.error(errorMessage, {
        onOpen: () => this.setState({ showingToast: true }),
        onClose: () => this.setState({ showingToast: false }),
      })
    }
  }

  reactToastify = () => {
    this.showErrorToast(
      this.state.actionError ||
        this.state.loadingError ||
        this.state.inspectedDateError,
    )
  }

  scrollToMissingRentalLedgerSection = (missingRentalHistoryGUIDs = []) => {
    const firstMissingRentalHistoryGUID = missingRentalHistoryGUIDs[0]
    const firstMissingSection =
      firstMissingRentalHistoryGUID &&
      document.querySelector(
        `[data-rental-history-guid="${firstMissingRentalHistoryGUID}"]`,
      )
    const section =
      firstMissingSection || this.addressHistorySectionRef?.current || null
    if (section && typeof section.scrollIntoView === 'function') {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  handleSubmitFailure = (error) => {
    const errorMessage = getSubmitFinalApplicationErrorMessage(error)
    if (isMissingRequiredRentalLedgerSubmitError(error)) {
      const missingRentalHistoryGUIDs =
        getMissingRequiredRentalLedgerHistoryGUIDs(error)
      this.setState(
        {
          submitBtnClicked: false,
          actionError: '',
          submitLedgerRecoveryError: {
            message: errorMessage,
            missingRentalHistoryGUIDs,
          },
        },
        () => {
          this.showErrorToast(errorMessage)
          this.scrollToMissingRentalLedgerSection(missingRentalHistoryGUIDs)
        },
      )
      return
    }

    this.setState(
      { submitBtnClicked: false, actionError: errorMessage },
      this.reactToastify,
    )
  }

  onFixMissingRentalLedger = (rentalHistoryGUID = '') => {
    const {
      match: {
        params: { applicationId },
      },
      applicant = {},
    } = this.props
    const { renterSummary = {} } = this.state
    const { property = {}, propertyOffer = {} } = renterSummary
    const { address = {}, agencyID = '' } = property
    const { friendlyName = '' } = address
    const { ballotsEnabled = false } = propertyOffer

    const rentalHistoryGUIDQuery = rentalHistoryGUID
      ? `&rentalHistoryGUID=${rentalHistoryGUID}`
      : ''
    const ledgerAnchor = rentalHistoryGUID
      ? `#${ledgerAttachmentsCmpDomId}`
      : ''
    const urlQueryString = `&address=${encodeURIComponent(
      friendlyName,
    )}&id=${agencyID}&applicationId=${applicationId}&isApplied=${
      applicant?.applied ? 'Submitted' : 'Draft'
    }&stage=essentials${rentalHistoryGUIDQuery}${ledgerAnchor}`

    this.setState({ submitLedgerRecoveryError: null, actionError: '' })
    const destinationURL = rentalHistoryGUID
      ? `${urlTo('updateRentalReference', {
          referenceId: rentalHistoryGUID,
        })}?from=rentersummary${ballotsEnabled ? '&ballot=true' : ''}`
      : `${urlTo('bondCoverRentalHistory')}?from=rentersummary${
          ballotsEnabled ? '&ballot=true' : ''
        }`
    this.onEditClick(urlQueryString)(destinationURL)
  }

  submitApplicationAsPrimary = (applicationID, data) => {
    const { submitFinalApplication } = this.props
    this.setState({ submitBtnClicked: true })
    submitFinalApplication(applicationID, data)
      .then(() => {
        const params = new URLSearchParams()
        params.set(UTILITY_CONNECTION_MODAL_QUERY_KEY, '1')
        history.push(
          `${urlTo('applyConfirmationSummary', {
            applicationId: applicationID,
          })}?${params.toString()}`,
        )
      })
      .catch((error) => {
        this.handleSubmitFailure(error)
      })
  }

  submitApplicationAsSecondary = (
    applicationID,
    applicantGUIDID,
    payload,
    data,
    providerName,
  ) => {
    this.props
      .acceptJointApplicationAsSecondary(
        applicationID,
        applicantGUIDID,
        payload,
        true,
        data,
      )
      .then(() => {
        history.push(
          urlTo('applyConfirmationSummary', { applicationId: applicationID }),
        )
      })
      .catch((error) => {
        this.handleSubmitFailure(error)
      })
  }

  toggleDisclosureOptions = (field) => {
    return () => {
      this.setState({
        [field]: !this.state[field],
      })
    }
  }

  toggleJoinApplicationModal = () => {
    this.setState({
      renterHasJointApplication: !this.state.renterHasJointApplication,
      submitBtnClicked: false,
    })
  }

  toggleOptedInAsSmoker = () => {
    this.setState(
      {
        optedInAsSmoker: !this.state.optedInAsSmoker,
      },
      () => {
        this.setState({
          smokingInfo: this.state.optedInAsSmoker
            ? smokingType.Smoker
            : smokingType.NonSmoker,
        })
      },
    )
  }

  hasAutoDeletedDocumentsInValue = (value, seen = new WeakSet()) => {
    if (!value) return false

    if (Array.isArray(value)) {
      return value.some((item) =>
        this.hasAutoDeletedDocumentsInValue(item, seen),
      )
    }

    if (typeof value !== 'object') {
      return false
    }

    if (seen.has(value)) {
      return false
    }
    seen.add(value)

    // Check fileAutoDeletedAt in both camelCase (API-transformed) and snake_case (raw API) forms
    if (isDocAutoDeleted(value)) {
      return true
    }
    if (value.file_auto_deleted_at) {
      return true
    }
    return Object.values(value).some((nestedValue) =>
      this.hasAutoDeletedDocumentsInValue(nestedValue, seen),
    )
  }

  hasAutoDeletedDocuments = () => {
    const { renterSummary = {} } = this.state
    return this.hasAutoDeletedDocumentsInValue(renterSummary)
  }

  validRequiredFields() {
    const { applicant = {}, renterSummary = {} } = this.props
    const { pets = [] } = renterSummary
    const { teamSettingInfo } = this.state
    const parsedTeamSettingInfo =
      (teamSettingInfo.application &&
        parseDataUtil.convertObjValueFromStringToBoolean(
          teamSettingInfo.application,
        )) ||
      {}
    const { enable_enhanced_disclosure: enableEnhancedDisclosure = false } =
      parsedTeamSettingInfo
    if (enableEnhancedDisclosure) {
      for (const question of yesOrNoDisclosureQuestions) {
        if (
          (question.required &&
            !this.state.disclosureYesOrNoAnswers[question.id]) ||
          (question.hasMoreDetails &&
            this.state.disclosureYesOrNoAnswers[question.id] === Yes &&
            !this.state.disclosureYesOrNoAnswers[question.moreDetailsId])
        ) {
          this.setState(
            {
              actionError: stringHelpers.ENHANCED_DISCLOSURES_ERROR,
            },
            this.reactToastify,
          )
          return false
        }
      }
    }

    if (applicant && applicant.isPrimary) {
      if (
        !this.state.optedToAcceptCondition &&
        !this.state.optedToSkipViewingDisclosures
      ) {
        const element = document.querySelector('.physically-inspected')
        element && element.scrollIntoView(true)
        this.setState(
          {
            actionError: stringHelpers.PROPERTY_CONDITION_ERROR_TEXT,
          },
          this.reactToastify,
        )
        return false
      }
      if (!this.state.optedToAcceptDisclosureConsent) {
        this.setState(
          {
            actionError: stringHelpers.DISCLOSURE_CONSENT_ERROR_TEXT,
          },
          this.reactToastify,
        )
        return false
      }
      if (pets.length > 0 && !this.state.optedInToPetConsent) {
        this.setState(
          {
            actionError: 'You must accept the pet regulations to continue',
          },
          this.reactToastify,
        )
        return false
      }
      if (
        this.state.conditionAcceptanceType ===
          PhysicalAndRemoteAcceptanceType &&
        this.state.propertyInspectionType === InspectionTypePhysical &&
        (this.state.propertyInspectedDate === null ||
          this.state.propertyInspectedDate === '')
      ) {
        this.setState(
          {
            actionError: 'Inspection date is required',
          },
          this.reactToastify,
        )
        return false
      }
      if (
        this.state.conditionAcceptanceType ===
          PhysicalAndRemoteAcceptanceType &&
        this.state.propertyInspectionType === InspectionTypePhysical &&
        !validations.isDateTodayOrEarlier(this.state.propertyInspectedDate)
      ) {
        this.setState(
          {
            inspectedDateError: 'Inspection date must be today or earlier',
          },
          this.reactToastify,
        )
        return false
      }
    }

    return true
  }

  renderAgencyApplicationsLimitAlert() {
    const { teamSettingInfo } = this.state
    const { submittedApplication } = this.props

    const applicantAgencySummary =
      submittedApplication?.applicant?.agencySummary
    const teamName = submittedApplication?.offer?.property?.teamName

    return (
      teamSettingInfo && (
        <AgencyApplicationsLimitAlert
          applicantApplicationsCount={applicantAgencySummary?.applicationsCount}
          teamName={teamName}
          applicationTeamSettings={teamSettingInfo.application}
        />
      )
    )
  }

  onChangeDisclosureYesOrNoQuestions(id, value) {
    const { actionError } = this.state

    this.setState(
      {
        disclosureYesOrNoAnswers: {
          ...this.state.disclosureYesOrNoAnswers,
          [id]: value,
        },
      },
      () => {
        if (actionError === stringHelpers.ENHANCED_DISCLOSURES_ERROR) {
          this.setState({
            actionError: '',
          })
        }
      },
    )
  }

  renderInvalidDataModal = () => {
    return (
      this.state.showInvalidDataModal && (
        <Modal
          toggleModal={this.toggleInvalidDataModal}
          modalHeading={'Invalid applicant detected'}
          modalBody={
            <Box>
              We've encountered an issue. Don't worry, your application has been
              saved.
              <br />
              <br />
              Please continue from{' '}
              <Link to={urlTo('MyApplications')}>My Applications</Link>.
            </Box>
          }
          primaryLabel={'Go to My Applications'}
          primaryAction={() => history.push(urlTo('MyApplications'))}
          secondaryLabel={'Cancel'}
          secondaryAction={this.toggleInvalidDataModal}
        />
      )
    )
  }

  renderAutoDeletedDocumentsModal = () => {
    return (
      this.state.autoDeletedDocumentsModalOpen && (
        <Modal
          toggleModal={this.toggleAutoDeletedDocumentsModal}
          modalHeading={'Remove auto-deleted documents'}
          modalBody={
            <Box>
              You have auto-deleted documents in your submission. Please delete
              these and try applying again.
            </Box>
          }
          primaryLabel={'Close'}
          primaryAction={this.toggleAutoDeletedDocumentsModal}
          showSecondaryButton={false}
        />
      )
    )
  }

  render() {
    const {
      match: {
        params: { applicationId },
      },
      currentUser = {},
      backgroundCheck = {},
      applicant = {},
      submittedApplication = {},
      completeness,
      propertyDisclosure,
      isQLDForm22 = false,
      loading = {},
    } = this.props
    const { firstName = '' } = currentUser
    const { conditionAcceptanceType, acknowledgeSupplyOfIDDocuments = false } =
      applicant || {}
    const {
      renterSummary = {},
      spinner = false,
      applicantLoading = false,
      preference = {},
      submitBtnClicked = false,
      loadingError = '',
      optedInAsSmoker = false,
      optedToAcceptCondition = false,
      optedToAcceptDisclosureConsent = true,
      optedToReceiveUtilityConnection = true,
      directConnectTermsViewed = false,
      optedToReceiveRayWhiteConciergeService = false,
      optedToReceiveBondLoanInformation = false,
      optedToRequirePostingClause = false,
      optedInToPetConsent = false,
      optedToReceiveEasyBondpay = false,
      teamSettingInfo = {},
      propertyInspectionType,
      propertyInspectedDate = null,
      renterHasJointApplication,
      showViewingCheckinModal,
      openAAModal,
      inspectedDateError,
      optedToSkipViewingDisclosures = false,
      applicationsCloseModalOpen,
      optedToAcceptRetainRentalProfile = false,
      displayProfileRetentionExtendedPeriod,
      displayProfileRetentionPeriod,
      displaySuccessfulApplicantRetentionPeriod,
      submitLedgerRecoveryError,
      financialInsightsReport,
    } = this.state
    const {
      application = {},
      rentalHistory = {},
      idDocumentsSummary = {},
      proofOfIncome = {},
      employers = [],
      pets = [],
      attachments = [],
      personalReferences = [],
      emergencyContacts = [],
      studentDetails = [],
      utilityProvider = {},
      totalWeeklyIncome = 0,
      renterJointApplication = {},
      selfTenancyCheck = {},
      autoresponderAttachments = [],
    } = renterSummary
    const idPoint =
      idDocumentsSummary.identityCheckPoints >= IDENTITY_POINT_THRESHOLD_VALUE
    let { property = {}, propertyOffer = {} } = renterSummary
    const { agencyID = '' } = renterSummary.property || {}
    if (!property) {
      property = {}
    }
    if (!propertyOffer) {
      propertyOffer = {}
    }
    const {
      applicants = [],
      applyAnywhereListing = {},
      applicationType = 0,
    } = application
    const { attachedToProfile = false } = backgroundCheck
    const {
      optOutBackgroundCheck = false,
      optOutEmploymentHistory = false,
      optOutPets = false,
      optOutRentalHistory = false,
      optInStudentDetails = false,
    } = preference

    // For renter summary, ALWAYS use current team settings
    // This ensures bank statements are shown/hidden based on the current team configuration,
    // not the settings that were stored when the application was created.
    // This allows PMs to change team settings and immediately see the effect on renter summary pages.
    const effectiveConfig = {
      ...application.config, // Keep all existing application config
      applicationsSettingsConfig: {
        ...application.config?.applicationsSettingsConfig, // Keep existing settings
        // Only override bank statement specific settings from team config
        bank_statement_require:
          teamSettingInfo?.application?.bank_statement_require,
        bank_statement_require_type:
          teamSettingInfo?.application?.bank_statement_require_type,
      },
    }
    const { applyOptions = {}, applicationsSettingsConfig = {} } =
      effectiveConfig
    const { allowApplicantToSkipViewingDisclosures = {} } = applyOptions || {}
    const {
      exclude_bankruptcy_report: excludeBGCBankruptcyReport = false,
      exclude_request_vehicle_registration:
        excludeRequestVehicleRegistration = false,
    } = applicationsSettingsConfig || {}

    const identityCapEnabled =
      teamSettingInfo &&
      teamSettingInfo.application &&
      teamSettingInfo.application.identity_cap_enabled &&
      teamSettingInfo.application.identity_cap_enabled === 'true'
    const { teamSlug = '' } = property
    const {
      applicantSummary = {},
      submittedDate = '',
      appliedAt = '',
    } = submittedApplication
    const chosenPropertyInfo = property.address
      ? property
      : applyAnywhereListing
    const { address = {} } = chosenPropertyInfo
    const { friendlyName = '', state = '' } = address || {}
    const stateDemonym = getStateDemonym(state)
    const isNotApplyAnywhereApplication =
      applicationType !== APPLY_ANYWHERE_APPLICATION
    const isApplyAnywhereApplication =
      applicationType === APPLY_ANYWHERE_APPLICATION
    const isRentalLedgerRequiredByAgencySetting =
      isRentalLedgerRequiredByAgencyPolicy(teamSettingInfo?.application)
    const {
      rentalHistoryVerified = false,
      employmentHistoryVerified = false,
      employmentHistoryPresent = false,
    } = completeness

    const shouldSubmitWithoutDelayNotice =
      (isApplyAnywhereApplication &&
        !applicationHelpers.shouldDelaySendingAAApplication(
          rentalHistoryVerified,
          employmentHistoryVerified,
          employmentHistoryPresent,
        )) ||
      isNotApplyAnywhereApplication
    const isApplicationEditable = !isApplicationAccepted(application)
    const submitApplicationTagClass = applyAnywhereListing
      ? 'apply-anywhere-submit-application'
      : 'rental-application-submit-application'
    const urlQueryString = `&address=${encodeURIComponent(
      friendlyName,
    )}&id=${agencyID}&applicationId=${applicationId}&isApplied=${
      applicant?.applied ? 'Submitted' : 'Draft'
    }`
    const urlQueryStringForEssentials = `${urlQueryString}&stage=essentials`

    const {
      hasPropertyDisclosure = false,
      propertyDisclosure: disclosures = {},
    } = propertyDisclosure

    const teamName = submittedApplication?.offer?.property?.teamName

    const backgroundCheckDate =
      backgroundCheck &&
      backgroundCheck.updatedAt &&
      backgroundCheck.updatedAt !== '0001-01-01T00:00:00Z'
        ? dateTimeHelpers.formatTime(
            backgroundCheck.updatedAt,
            'hh:mm DD MMM YYYY',
          )
        : ''

    const { publicConfig = {} } = application || {}
    const { agencyOptions = {} } = publicConfig || {}
    const { idDocsNotRequested = false } = agencyOptions || {}
    const { ballotsEnabled = false } = propertyOffer || {}

    const hideBGCheckSection =
      ballotsEnabled || checkIfBGCheckNotSupportedInState(state)

    const renderApplicationHeader = () => {
      const submitted = applicant && applicant.applied

      if (submitted) {
        return (
          <Box mb="15px">
            <Alert variant="successWithBg">
              <Flex alignItems="center" justifyContent="start">
                <StyledDoneIconContainer mr={`${theme.space[5]}px`}>
                  <DoneRounded color={theme.colors.success700} />
                </StyledDoneIconContainer>

                <TextSpan fontWeight={theme.fontWeights[6]}>SUBMITTED</TextSpan>
              </Flex>
            </Alert>
          </Box>
        )
      }

      return (
        <Box mb="15px">
          <Alert variant="blueWithBg">
            <TextSpan fontWeight="700">DRAFT</TextSpan>
            <TextSpan>, please submit when ready</TextSpan>
          </Alert>
        </Box>
      )
    }

    const isApplicationLoading =
      loading.applicationSummary || loading.propertySummary || applicantLoading

    if ((spinner || isApplicationLoading) && !loadingError) {
      return (
        <div className="mt100">
          <Spinner />
        </div>
      )
    }

    // Show warning if applicant is still null after loading
    if (!isApplicationLoading && isEmpty(applicant) && !loadingError) {
      return (
        <Box mb="15px">
          <Alert
            showLeftIcon
            leftIconVariant="warning"
            variant="warningWithBg"
            type="error"
          >
            <Box>
              We've encountered an issue. Don't worry, your application has been
              saved.{' '}
              <LinkStyleText
                fontSize={theme.fontSizes.pLarge16}
                fontWeight="unset"
                onClick={() => window.location.reload()}
              >
                Reload
              </LinkStyleText>{' '}
              or continue from{' '}
              <Link to={urlTo('MyApplications')}>My Applications</Link>.
            </Box>
          </Alert>
        </Box>
      )
    }

    return (
      <div>
        <Display.CenterContentContainer>
          <ProgressBarComponent
            completeness={completeness}
            applied={applicant && applicant.applied}
          />

          {renderApplicationHeader()}

          {loadingError && (
            <div className="alert alert-danger mt50">{loadingError}</div>
          )}
          {!spinner && !loadingError && (
            <div>
              {isApplicationApplyAnywhere(application.applicationType) && (
                <SummaryHeaders.ApplyAnywhereApplicationHeader
                  isApplyAnywhereHeadEditable={isApplicationEditable}
                  application={application}
                  property={chosenPropertyInfo}
                />
              )}
              {isNotApplyAnywhereApplication && (
                <SummaryHeaders.ApplicationSummaryHeader
                  property={chosenPropertyInfo}
                  propertyOffer={propertyOffer}
                  applicationType={applicationType}
                />
              )}
            </div>
          )}
        </Display.CenterContentContainer>
        {!spinner && !loadingError && (
          <div>
            <Display.CenterContentContainer componentClass="application-standard-shadow-box col-xs-12 summary-box-on-mobile">
              <div className="mb0">
                <Headers.SectionHeader text="My Details" textClass="fw600" />
                <HouseholdContainer
                  application={application}
                  isHouseholdEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryString)}
                  componentClassName="bbs"
                  isQLDForm={isQLDForm22}
                />
                <PreferenceComponent
                  application={application}
                  applicants={applicants}
                  property={chosenPropertyInfo}
                  isSummaryEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryString)}
                  totalEmployedWeeklyNetIncome={totalWeeklyIncome}
                  propertyOffer={propertyOffer}
                  isManagerSummary={false}
                  teamSettingInfo={teamSettingInfo}
                  excludeRequestVehicleRegistration={
                    excludeRequestVehicleRegistration
                  }
                  isQLDForm22={isQLDForm22}
                />
              </div>
            </Display.CenterContentContainer>
            <Display.CenterContentContainer componentClass="application-standard-shadow-box mt80 col-xs-12 summary-box-on-mobile">
              <div className="mb0">
                <Headers.SectionHeader text="Essential" textClass="fw600" />
                <div ref={this.addressHistorySectionRef}>
                  <AddressHistoryComponent
                    rentalHistory={rentalHistory}
                    optOutRentalHistory={optOutRentalHistory}
                    isRentalLedgerRequiredByAgencyPolicy={
                      isRentalLedgerRequiredByAgencySetting
                    }
                    showSubmitLedgerError={Boolean(submitLedgerRecoveryError)}
                    submitLedgerErrorMessage={
                      submitLedgerRecoveryError?.message || ''
                    }
                    missingRentalHistoryGUIDs={
                      submitLedgerRecoveryError?.missingRentalHistoryGUIDs || []
                    }
                    onFixMissingRentalLedger={this.onFixMissingRentalLedger}
                    isAddressHistoryEditable={isApplicationEditable}
                    onEditClick={this.onEditClick(urlQueryStringForEssentials)}
                    componentClassName="bbs"
                    ballotsEnabled={ballotsEnabled}
                    renterName={firstName}
                    isQLDForm22={isQLDForm22}
                  />
                </div>
                <EmploymentContainer
                  employers={employers}
                  optOutEmploymentHistory={optOutEmploymentHistory}
                  isEmploymentEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryStringForEssentials)}
                  componentClassName="bbs"
                  ballotsEnabled={ballotsEnabled}
                  isQLDForm={isQLDForm22}
                />
                <RenterVerifiedFinancialsContainer
                  verifiedIncome={financialInsightsReport}
                  attachedToProfile={Boolean(
                    financialInsightsReport?.attachedToProfile,
                  )}
                />
                <IncomeContainer
                  proofOfIncome={proofOfIncome}
                  isIncomeEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryStringForEssentials)}
                  componentClassName="bbs"
                  ballotsEnabled={ballotsEnabled}
                  isQLDForm22={isQLDForm22}
                  applicationDetails={{
                    ...application,
                    config: effectiveConfig,
                  }}
                />

                <IdentityDocumentsContainer
                  identityDocs={idDocumentsSummary?.identityDocs}
                  supportingIdentityDocs={
                    idDocumentsSummary.supportingIdentityDocs
                  }
                  identityCheckPoints={idDocumentsSummary.identityCheckPoints}
                  isIdentityDocumentsEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryStringForEssentials)}
                  componentClassName="no-box-shadow summary-container-padding pb0 bbs"
                  agencyID={agencyID}
                  idDocsNotRequested={idDocsNotRequested}
                  acknowledgeSupplyOfIDDocuments={
                    acknowledgeSupplyOfIDDocuments
                  }
                  showManagerAlertTextForIDDocs={false}
                  selfTenancyCheck={selfTenancyCheck}
                  ballotsEnabled={ballotsEnabled}
                  isQLDForm22={isQLDForm22}
                  identityCapEnabled={identityCapEnabled}
                />
                {!hideBGCheckSection && (
                  <BackgroundCheckContainer
                    firstName={firstName}
                    optOutBackgroundCheck={optOutBackgroundCheck}
                    attachedToProfile={attachedToProfile}
                    isBackgroundCheckEditable={isApplicationEditable}
                    onEditClick={this.onEditClick(urlQueryString)}
                    backgroundCheck={backgroundCheck}
                    backgroundCheckDate={backgroundCheckDate}
                    fetchBackgroundCheckReportDetails={
                      this.props.fetchBackgroundCheckReportDetails
                    }
                    excludeBGCBankruptcyReport={excludeBGCBankruptcyReport}
                  />
                )}
              </div>
            </Display.CenterContentContainer>
            <Display.CenterContentContainer componentClass="application-standard-shadow-box mt80 col-xs-12 summary-box-on-mobile">
              <div className="mb0">
                <Headers.SectionHeader text="Supporting" textClass="fw600" />
                {!isQLDForm22 && (
                  <EmergencyContactContainer
                    emergencyContacts={emergencyContacts}
                    isEmergencyContactsEditable={isApplicationEditable}
                    onEditClick={this.onEditClick(urlQueryString)}
                    componentClassName="bbs"
                  />
                )}
                <PersonalReferenceContainer
                  personalReferences={personalReferences}
                  isPersonalReferenceEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryString)}
                />
              </div>
            </Display.CenterContentContainer>
            <Display.CenterContentContainer componentClass="application-standard-shadow-box mt80 col-xs-12 summary-box-on-mobile">
              <div className="mb0">
                <Headers.SectionHeader text="Extras" textClass="fw600" />
                <PetsContainer
                  pets={pets}
                  optOutPets={optOutPets}
                  isRenterDisplay="true"
                  isPetsEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryString)}
                  componentClassName="bbs"
                  isQLDForm22={isQLDForm22}
                />
                {!isQLDForm22 && (
                  <StudentContainer
                    students={studentDetails}
                    optInStudentDetails={optInStudentDetails}
                    isStudentEditable={isApplicationEditable}
                    onEditClick={this.onEditClick(urlQueryString)}
                    componentClassName="bbs"
                  />
                )}
                <OtherDocumentContainer
                  attachments={attachments}
                  isOtherDocumentEditable={isApplicationEditable}
                  onEditClick={this.onEditClick(urlQueryString)}
                  componentClassName="bbs"
                />
                <Display.SectionContentContainer>
                  <Text.Strong
                    text="Important Information"
                    textClass="fw500 fs24 lh24"
                    linkAdded={false}
                  />

                  <Display.FlexContainer containerClass="mt15">
                    <DisclosureQuestionsDisplay
                      propertyDisclosure={disclosures}
                      hasPropertyDisclosure={hasPropertyDisclosure}
                      autoresponderAttachments={autoresponderAttachments}
                    />
                  </Display.FlexContainer>
                </Display.SectionContentContainer>
                <DisclosureConsentContainer
                  isPrimaryApplicant={applicant?.isPrimary || false}
                  optedInAsSmoker={optedInAsSmoker}
                  toggleOptedInAsSmoker={this.toggleOptedInAsSmoker}
                  optedToAcceptCondition={optedToAcceptCondition}
                  optedToAcceptDisclosureConsent={
                    optedToAcceptDisclosureConsent
                  }
                  optedToReceiveUtilityConnection={
                    optedToReceiveUtilityConnection
                  }
                  directConnectTermsViewed={directConnectTermsViewed}
                  optedToReceiveRayWhiteConciergeService={
                    optedToReceiveRayWhiteConciergeService
                  }
                  optedToReceiveBondLoanInformation={
                    optedToReceiveBondLoanInformation
                  }
                  optedToRequirePostingClause={optedToRequirePostingClause}
                  optedInToPetConsent={optedInToPetConsent}
                  optedToReceiveEasyBondpay={optedToReceiveEasyBondpay}
                  utilityProviderName={utilityProvider.name}
                  teamSettingInfo={teamSettingInfo}
                  toggleDisclosureOptions={this.toggleDisclosureOptions}
                  conditionAcceptanceType={conditionAcceptanceType}
                  propertyInspectionType={propertyInspectionType}
                  onChangeInspectionType={this.onChangeInspectionType}
                  onPropertyInspectedDateUpdate={
                    this.onPropertyInspectedDateUpdate
                  }
                  pets={pets}
                  propertyInspectedDate={propertyInspectedDate}
                  error={inspectedDateError}
                  propertyOffer={propertyOffer}
                  teamName={teamName}
                  onChangeDisclosureYesOrNoQuestions={(id, value) => {
                    this.onChangeDisclosureYesOrNoQuestions(id, value)
                  }}
                  disclosureYesOrNoAnswers={this.state.disclosureYesOrNoAnswers}
                  submittedDate={submittedDate}
                  appliedAt={appliedAt}
                  allowApplicantToSkipViewingDisclosures={
                    allowApplicantToSkipViewingDisclosures
                  }
                  optedToSkipViewingDisclosures={optedToSkipViewingDisclosures}
                  optedToAcceptRetainRentalProfile={
                    optedToAcceptRetainRentalProfile
                  }
                  isQLDForm22={isQLDForm22}
                  displayProfileRetentionExtendedPeriod={
                    displayProfileRetentionExtendedPeriod
                  }
                  displayProfileRetentionPeriod={displayProfileRetentionPeriod}
                />
              </div>

              {application && Object.keys(application).length && (
                <>{this.renderAgencyApplicationsLimitAlert(false)}</>
              )}
              <AlertInfo
                m={`${theme.space[7]}px`}
                message={
                  'To protect your privacy, applications are automatically withdrawn after 60 days.' +
                  (displaySuccessfulApplicantRetentionPeriod
                    ? `\n${stateDemonym} regulations require the successful applicant (s) Renter Profile and Applications to be removed after ${displaySuccessfulApplicantRetentionPeriod}.`
                    : '')
                }
              ></AlertInfo>
              {isQLDForm22 && <TenancyDatabases m={`${theme.space[7]}px`} />}
            </Display.CenterContentContainer>
          </div>
        )}

        <Display.BottomContentContainer>
          <Display.CenterContentContainer componentClass="width100">
            <div className="submit-button-container">
              <BottomButton
                showArrow={false}
                btnText={this.btnTextChange()}
                bottomButtonsClass="pt0 mt0 summary-bottom-button"
                nextBtnId={!applicant?.applied ? `${teamSlug}` : ''}
                nextBtnDisabled={submitBtnClicked}
                clickNextFunction={
                  shouldSubmitWithoutDelayNotice
                    ? () => {
                        this.setState({ submitBtnClicked: true })
                        this.onSubmitClick(
                          applicant,
                          applicationId,
                          applicantSummary,
                          utilityProvider.name,
                          idPoint,
                        )
                      }
                    : () => this.setState({ openAAModal: true })
                }
                nextBtnClass={`summary-green-button-class ${
                  !applicant?.applied ? submitApplicationTagClass : ''
                }`}
                backButtonClass="summary-grey-button-class"
                nextButtonPositionClass="pr20 pl0"
              />
            </div>
          </Display.CenterContentContainer>
        </Display.BottomContentContainer>
        {showViewingCheckinModal && (
          <BasicModal
            toggleModal={this.onToggleModal}
            title={
              'Please inspect the property before submitting the application'
            }
            body={
              <div>
                <p>
                  This property manager requires at least one applicant to have
                  inspected the property before applying.
                </p>
                <p>
                  Don&apos;t worry, your Snug profile and application draft have
                  been saved. Please register to view the property using the
                  same email address or mobile number used in your application.
                  Once checked in, you can submit your application.
                </p>
              </div>
            }
            primaryButtonLabel={'Book a time'}
            primaryButtonAction={() => this.onBookATimeButtonClicked(property)}
            showSecondaryButton={false}
          />
        )}
        {renterHasJointApplication && (
          <Display.Modal
            title="Submit Application"
            hideButtonSection={true}
            toggleModal={() => this.toggleJoinApplicationModal()}
          >
            <div className="text-center">
              You are already invited on a submitted application for{' '}
              <strong>{friendlyName}</strong> with{' '}
              <strong>
                {renterJointApplication?.applicant?.firstName}{' '}
                {renterJointApplication?.applicant?.lastName}
              </strong>
              . Join your application to speed up processing. Your current draft
              will be saved.
            </div>
            <Display.ModalButtonGroup
              primaryLabel="Join application"
              secondaryLabel="Submit separately"
              secondaryButtonType="tertiary"
              primaryAction={() => {
                this.setState({ submitBtnClicked: true })
                this.joinApplication(applicant, renterJointApplication)
              }}
              secondaryAction={() => {
                this.setState({ submitBtnClicked: true })
                this.onApplyButtonClick(
                  applicant,
                  applicationId,
                  applicantSummary,
                  utilityProvider.name,
                )
              }}
            />
          </Display.Modal>
        )}
        {openAAModal && (
          <Display.Modal
            toggleModal={this.onCloseModal}
            title="Submit Application"
            hideButtonSection
          >
            <div className="fs16">
              <p>
                Once you submit, your rental references and employment
                confirmation will be requested from your nominated contacts
                before delivering your application (up to 24 hours). Once your
                references and employment confirmation are complete, future
                applications will be delivered when submitted.
              </p>
            </div>
            <Display.ModalButtonGroup
              primaryLabel="Submit"
              secondaryLabel="Cancel"
              secondaryButtonType="tertiary"
              primaryAction={() => this.onClickOkButton()}
              secondaryAction={this.onCloseModal}
            />
          </Display.Modal>
        )}
        {applicationsCloseModalOpen && (
          <ApplicationClosedModal
            teamSlug={teamSlug}
            teamName={teamName}
            toggleApplicationsCloseModal={this.toggleApplicationsCloseModal}
          />
        )}
        {this.renderAutoDeletedDocumentsModal()}
        {this.renderInvalidDataModal()}
      </div>
    )
  }
}

export default ApplicationSummaryContainer
